var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root",class:{
    'root-media': _vm.variant === 'media',
    'root-technology': _vm.variant === 'technology'
  },on:{"click":function($event){return _vm.onStoryClick(_vm.story.slug)}}},[_c('div',{staticClass:"card",class:{
    'card-media': _vm.variant === 'media',
    'card-technology': _vm.variant === 'technology'
  }},[_c('img',{staticClass:"image",attrs:{"src":_vm.urlFor(_vm.story.image).width(350).url()}}),_c('div',{staticClass:"text-container",class:{
        'text-container-technology': _vm.variant === 'technology'
      }},[_c('div',{staticClass:"department",class:{
        'department-technology': _vm.variant === 'technology'
      }},[_vm._v(" "+_vm._s(_vm.shortDepartment)+" ")]),_c('div',{staticClass:"text"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.story.title))]),_c('p',{staticClass:"excerpt"},[_vm._v(_vm._s(_vm.shortExcerpt))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }